import { EventObject } from '@xstate/store-react';
import { InitOptions } from '@domgen/checkout-sdk-types';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { log } from '@domgen/shared/src/utils/log';

/**
 * Stores prepared checkout initialization data and clears loading state.
 *
 * @param context Current store context.
 * @param event Event containing checkout init options.
 * @returns Updated context with checkout payload.
 */
export const setCheckout = <T extends EventObject = EventObject>(
  context: StoreContext,
  event: T & { data: InitOptions },
): StoreContext => {
  log.debug({ message: StoreEvent.SET_CHECKOUT, data: event.data });
  return {
    ...context,
    checkout: {
      loading: false,
      data: event.data,
    },
  };
};
